<!--
 * @Author: Czy
 * @Date: 2024-12-23 09:55:32
 * @FilePath: /bikecat/src/components/sub-message/sub-message.vue
 *  
-->
<template>
  <wd-overlay :show="show" @click="closeModal" lockScroll>
    <!-- <wd-message-box selector="sub-message-box" customClass="!bg-[#F3F3F5]"> -->
    <view class="h-full flex justify-center items-center w-full">
      <view
        class="flex !bg-[#F3F3F5] flex-col w-auto rounded-[36rpx] justify-center items-center relative text-[28rpx] lh-[39rpx] px-[20rpx] py-[60rpx] box-border mx-[60rpx]"
      >
        <image
          src="https://hx-mp-res.hitrips.cn/bikecat/sub-message-top.png"
          mode="scaleToFill"
          class="w-[210rpx] h-[210rpx] absolute mt-[-50rpx] left-[34%] z-[9] top-[-60rpx]"
        />
        <view class="text-[36rpx] lh-[50rpx] font-700 mb-[36rpx] mt-[20rpx]">{{ title }}</view>
        <!-- 取消 -->
        <template v-if="type == 'cancelMessage'">
          <view
            class="bg-[#fff] flex-1 w-full box-border flex flex-col mx-[20rpx] p-[30rpx] rounded-[24rpx]"
          >
            <view class="text-[#767675]">
              <text>下单时间：</text>
              {{ useOrderStore().subMessageData?.cancelMessage?.reservationTime }}
            </view>
            <view class="text-[30rpx] flex items-center !font-[bold] mt-1">
              预订的
              <dict-text
                type="bikecat_order_type"
                :value="useOrderStore().subMessageData?.cancelMessage?.orderType"
              />
              <!-- {{
                useOrderStore().subMessageData?.cancelMessage?.orderType == 'SCENIC_TICKET'
                  ? '门票订单'
                  : '酒店订单'
              }} -->

              订单已取消
            </view>
          </view>
        </template>

        <!-- 担保金退回 -->
        <template v-if="type == 'earnestMessage'">
          <view
            class="bg-[#fff] flex-1 w-full box-border flex flex-col mt-[24rpx] mx-[20rpx] p-[30rpx] rounded-[24rpx]"
          >
            <view class="text-[#FF4222] text-[32rpx] flex items-center justify-between">
              <text>退款成功</text>
              <text>
                {{ languageStore.currencyCode
                }}{{ useOrderStore().subMessageData?.earnestMessage?.refundPrice }}
              </text>
            </view>
            <view class="mt-[24rpx] bg-[#F8F8FA] rounded-[12rpx] p-[16rpx]">
              <view class="text-[#767675] text-[24rpx]">
                {{ useOrderStore().subMessageData?.earnestMessage?.reservationTime }}
              </view>

              <view class="flex items-center justify-between mt-[12rpx]">
                担保金
                <text class="text-[#767675] font-700">
                  {{ languageStore.currencyCode }}
                  {{ useOrderStore().subMessageData?.earnestMessage?.earnestPrice }}
                </text>
              </view>
            </view>
          </view>
        </template>

        <!-- 房费退还 -->
        <template v-if="type == 'roomPriceChangeMessage'">
          <view
            class="bg-[#fff] flex-1 w-full box-border flex flex-col mx-[20rpx] p-[30rpx] rounded-[24rpx]"
          >
            <view class="text-[#767675]">
              <text>下单时间：</text>
              {{ useOrderStore().subMessageData?.roomPriceChangeMessage?.reservationTime }}
            </view>
            <view class="text-[30rpx] flex items-center justify-between !font-[bold] mt-1">
              预订的酒店订单已退回
            </view>
          </view>
          <view
            class="bg-[#fff] flex-1 w-full box-border flex flex-col mt-[24rpx] mx-[20rpx] p-[30rpx] rounded-[24rpx]"
          >
            <view class="text-[#FF4222] text-[32rpx]">房费退改</view>
            <view
              v-for="(
                item, index
              ) in useOrderStore().subMessageData?.roomPriceChangeMessage?.detailList.slice(0, 3)"
              :key="index"
              class="mt-[24rpx] bg-[#F8F8FA] rounded-[12rpx] p-[16rpx]"
            >
              <view class="text-[#767675] text-[24rpx]">{{ item?.nightTime }}</view>

              <view class="flex items-center justify-between mt-[12rpx]">
                房费
                <text class="text-[#767675] font-700">
                  {{ languageStore.currencyCode }} {{ item?.priceChangeValue }}
                </text>
              </view>
              <view class="flex items-center justify-between mt-[4rpx]">
                税费以及服务费
                <text class="text-[#767675] font-700">
                  {{ languageStore.currencyCode }} {{ item?.taxChangeValue }}
                </text>
              </view>
            </view>
          </view>
        </template>

        <view class="flex justify-between items-center mt-[40rpx]" @click.stop="">
          <wd-button
            block
            plain
            hairline
            custom-class="!h-96rpx !border-[1px] !text-lg !w-[254rpx] !bg-[#F3F3F5] !text-[#767675]"
            type="info"
            @click="closeModal"
          >
            返回
          </wd-button>

          <wd-button
            block
            custom-class="!h-96rpx !text-lg !w-[254rpx] ml-[36rpx]"
            @click="goDetail"
          >
            去查看
          </wd-button>
        </view>
      </view>
    </view>
  </wd-overlay>
  <!-- </wd-message-box> -->
</template>

<script lang="ts" setup>
//
import { useMessage } from 'wot-design-uni'
import { useOrderStore, useLanguageStore } from '@/store/index'
import { navigateTo } from '@/utils/navigateTo'
const show = ref(false)

const languageStore = useLanguageStore()

const message = useMessage('sub-message-box')
const openMessage = () => {
  show.value = true
}

const goDetail = () => {
  closeModal()
  navigateTo('/pages-sub/my-order/index', { type: 4 }, 'reLaunch')
}
const closeModal = () => {
  useOrderStore().showSubMessage = false
  show.value = false
}

watch(
  () => useOrderStore().showSubMessage,
  () => {
    if (useOrderStore().showSubMessage) {
      openMessage()
    } else {
      closeModal()
    }
  },
  { deep: true },
)
const title = computed(() => {
  return (
    useOrderStore().subMessageData?.cancelMessage?.title ||
    useOrderStore().subMessageData?.earnestMessage?.title ||
    useOrderStore().subMessageData?.roomPriceChangeMessage?.title
  )
})

const type = computed(() => {
  if (useOrderStore().subMessageData?.cancelMessage) {
    return 'cancelMessage'
  } else if (useOrderStore().subMessageData?.earnestMessage) {
    return 'earnestMessage'
  } else {
    return 'roomPriceChangeMessage'
  }
})
</script>

<style lang="scss" scoped>
//
:deep(.wd-message-box__body) {
  color: red;
  background: red !important;
}
</style>
